<template>
    <div class="wrapper">
<!--        <div class="flash-message" hidden>-->
<!--            <p class="flash-message&#45;&#45;text">Uzavřel jste ventil patního vodoměru. Přísun vody do objektu je nyní zamezen</p>-->
<!--            <button class="flash-message&#45;&#45;button">-->
<!--                <svg width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><title>x</title><path d="M9.67,0h0L5,4.68H5L.32,0h0L0,.32H0L4.67,5h0L0,9.68H0L.32,10h0L5,5.32H5L9.67,10h0L10,9.68h0L5.32,5h0L10,.32h0Z" transform="translate(0)" fill="#fff"/></svg>-->
<!--            </button>-->
<!--        </div>-->
<!--        <sidebar-menu></sidebar-menu>-->
        <main-header></main-header>
        <dashboard-filter v-on:dashboardFilterChanged="updateGraphs"></dashboard-filter>
            <graph-group v-for="structure in currentDashboard.structures" v-bind="structure" v-bind:key="structure.id" v-on:open-popup="openPopup"></graph-group>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import DashboardFilter from "@/components/PageComponents/DashboardFilter";
    import MainHeader from "@/components/PageComponents/MainHeader";
    import GraphGroup from "@/components/Widgets/GraphGroup";
    export default {
        name: "DashboardPage",
        components: {GraphGroup, DashboardFilter, MainHeader },
        computed: {
            ...mapState("structure", ["currentDashboard"])
        },
        methods: {
          updateGraphs: function () {
            this.$store.dispatch("structure/fetchForCurrentObject");

            for (let i = 0; i < this.$children.length; i++) {
              if(this.$children.hasOwnProperty(i) && this.$children[i].updateGraphs){
                this.$children[i].updateGraphs();
              }
            }
          },
          openPopup: function(data) {
            this.$emit('open-popup', data);
          }
        },
        created() {
        }
    };
</script>

<style scoped lang="less">
    .dashboard {
        &--wrapper {
          padding: 20px 25px;
          @media (max-width: 767px) {
            padding: 20px 10px;
          }
        }
    }
    .flash-message {
        position: fixed;
        top: 0;
        left: 0;
        padding: 10px 15px 10px 205px;
        width: 100%;
        background: #fb598a;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 48px;
        z-index: 10;
        &:before {
            content: '';
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            height: 16px;
            background: linear-gradient(180deg, #9f0634 0%, rgba(159, 7, 53, 0) 100%);
            opacity: 0.43;
        }
        &--text {
            font-size: 0.75rem;
            font-weight: 700;
            color: #f8f7f9;
            width: 100%;
            text-align: left;
        }
        &--button {
            padding: 10px;
            margin: 0;
            background: none;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
